import React, { useLayoutEffect, useRef } from 'react'

import LoadingIndicator from '@/assets/images/loading_indicator.gif'
import { FetchMoreStatus } from '@/types'

interface Props {
  maxHeight?: string
  fetchMoreStatus?: FetchMoreStatus
  onFetchMore?: () => void
  children: React.ReactNode
}

const InfiniteLoader: React.FC<Props> = ({
  maxHeight,
  fetchMoreStatus,
  onFetchMore,
  children,
}) => {
  const observerRef = useRef<HTMLDivElement>(null)
  const callback = useRef(onFetchMore)

  useLayoutEffect(() => {
    callback.current = onFetchMore
  }, [onFetchMore])

  useLayoutEffect(() => {
    if (!observerRef.current) return undefined

    const observer = new IntersectionObserver(
      entities => {
        if (entities.some(entity => entity.isIntersecting)) {
          callback.current?.()
        }
      },
      {
        threshold: 0.1,
      },
    )

    observer.observe(observerRef.current)

    return () => observer.disconnect()
  }, [])

  return (
    <div className="infinite-loader-wrapper" style={{ maxHeight }}>
      {children}
      {fetchMoreStatus === 'hasNextPage' && (
        <div ref={observerRef} className="infinite-loader">
          <img src={LoadingIndicator} />
        </div>
      )}
    </div>
  )
}

export default React.memo(InfiniteLoader)
